



import Vue from "vue";
import { Component, Watch, Prop } from "vue-property-decorator";
import { type } from "os";

@Component({
  name: "uc-map"
})
export default class UcMapComponent extends Vue {
  @Prop({ default: "map99" }) name: string;
  @Prop({ default: "terrain" }) mapType: string;
  @Prop({ default: "100%" }) width: string;
  @Prop({ default: "640px" }) height: string;
  @Prop({ default: 46.8414663 }) lat: number;
  @Prop({ default: 29.6127758 }) lng: number;
  @Prop({ default: 15 }) zoom: number;

  //46.8414663,29.6127758 - тирасполь

  //  initMap(){

  //       const ee=  new this.google.maps.Map(document.getElementById('map'))
  style={}
  created(){
    this.style={width:this.width,height:this.height}
  }

  // mounted() {
  //   const el = document.getElementById(this.name);
  //   const latLng = new google.maps.LatLng(this.lat, this.lng);
  //   const options = {
  //     zoom: this.zoom,
  //     center: latLng
  //   };
  //   const map = new google.maps.Map(el, options);
  // }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./scripts/views/components/uc-map.vue